import {
  SET_FORM_SETTINGS,
  ADD_FORM_FIELD,
  REMOVE_FORM_FIELD,
  SET_FORM_FIELDS,
  SET_EDITING_FIELD,
  SET_ALL_FORMS,
  SET_FORMS_TOTAL_PAGES,
  SET_FORMS_CURRENT_PAGE,
  DELETE_FROM_FIELD,
  SET_SINGLE_FORM,
  SET_CURR_SETTINGS,
  SET_FILL_FORMS,
  FILL_FORMS_TOTAL_PAGES,
  ACCESS_LIST_CURRENT_PAGE,
  REMOVE_SINGLE_FORM_FILL,
  SET_SINGLE_FORM_FILL,
  FORM_INPUT_SEARCH,
  FILL_FORM_TOTAL_DOCS,
  ADD_FORM_FIELD_AT_INDEX,
} from "../../@jumbo/constants/ActionTypes";

export const setFormSettings = (settings) => {
  return (dispatch) => {
    dispatch({
      type: SET_FORM_SETTINGS,
      payload: settings,
    });
  };
};

export const setFillForms = (forms) => {
  return (dispatch) => {
    dispatch({
      type: SET_FILL_FORMS,
      payload: forms,
    });
  };
};

export const setFillFormsCurrentPage = (curr) => {
  return (dispatch) => {
    dispatch({
      type: ACCESS_LIST_CURRENT_PAGE,
      payload: curr,
    });
  };
};

export const setFillFormsTotalPages = (totalPage) => {
  return (dispatch) => {
    dispatch({
      type: FILL_FORMS_TOTAL_PAGES,
      payload: totalPage,
    });
  };
};

export const setFormFields = (formFields) => {
  return (dispatch) => {
    dispatch({
      type: SET_FORM_FIELDS,
      payload: formFields,
    });
  };
};

export const addFormField = (formFleld) => {
  return (dispatch) => {
    dispatch({
      type: ADD_FORM_FIELD,
      payload: formFleld,
    });
  };
};


export const addFormFieldAtIndex = (formFleld,index) => {
  return (dispatch) => {
    dispatch({
      type: ADD_FORM_FIELD_AT_INDEX,
      payload: {
        index: index,
        field: formFleld
      }
    });
  };
};

export const removeFormField = (formField) => {
  return (dispatch) => {
    dispatch({
      type: REMOVE_FORM_FIELD,
      payload: formField,
    });
  };
};

export const setEditingField = (editingField) => {
  return (dispatch) => {
    dispatch({
      type: SET_EDITING_FIELD,
      payload: editingField,
    });
  };
};

export const setAllForms = (forms) => {
  return (dispatch) => {
    dispatch({
      type: SET_ALL_FORMS,
      payload: forms,
    });
  };
};

export const setformTotalpages = (totalPages) => {
  return (dispatch) => {
    dispatch({
      type: SET_FORMS_TOTAL_PAGES,
      payload: totalPages,
    });
  };
};

export const setformCurrentpage = (currentPage) => {
  return (dispatch) => {
    dispatch({
      type: SET_FORMS_CURRENT_PAGE,
      payload: currentPage,
    });
  };
};

export const deleteForm = (id) => {
  return (dispatch) => {
    dispatch({
      type: DELETE_FROM_FIELD,
      payload: id,
    });
  };
};

export const setSingleForm = (form) => {
  return (dispatch) => {
    dispatch({
      type: SET_SINGLE_FORM,
      payload: form,
    });
  };
};

export const setCurrSettings = (currSettings) => {
  return (dispatch) => {
    dispatch({
      type: SET_CURR_SETTINGS,
      payload: currSettings,
    });
  };
};

export const removeSingleFormFilled = (id) => {
  return (dispatch) => {
    dispatch({
      type: REMOVE_SINGLE_FORM_FILL,
      payload: id,
    });
  };
};

export const setSingleFormFill = (fillForm) => {
  return (dispatch) => {
    dispatch({
      type: SET_SINGLE_FORM_FILL,
      payload: fillForm,
    });
  };
};

export const setFormInputSearch = (search) => {
  return (dispatch) => {
    dispatch({
      type: FORM_INPUT_SEARCH,
      payload: search,
    });
  };
};

export const setFillFormToatalDocs = (docs) => {
  return (dispatch) => {
    dispatch({
      type: FILL_FORM_TOTAL_DOCS,
      payload: docs,
    });
  };
};
